import _regeneratorRuntime from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */
import { Dataset } from '../dataset';
/**
 * Represents a potentially large collection of text lines.
 *
 * The results are not batched.
 */

export var TextLineDataset = /*#__PURE__*/function (_Dataset) {
  _inherits(TextLineDataset, _Dataset);

  /**
   * Create a `TextLineDataset`.
   *
   * @param input A `DataSource` providing a chunked, UTF8-encoded byte stream.
   */
  function TextLineDataset(input) {
    var _this;

    _classCallCheck(this, TextLineDataset);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextLineDataset).call(this));
    _this.input = input;
    return _this;
  }

  _createClass(TextLineDataset, [{
    key: "iterator",
    value: function () {
      var _iterator = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var inputIterator, utf8Iterator, lineIterator;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.input.iterator();

              case 2:
                inputIterator = _context.sent;
                utf8Iterator = inputIterator.decodeUTF8();
                lineIterator = utf8Iterator.split('\n').map(function (line) {
                  // Windows/DOS format text file has extra line breaker at the end of line.
                  if (line.endsWith('\r')) {
                    line = line.slice(0, -1);
                  }

                  return line;
                });
                return _context.abrupt("return", lineIterator);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function iterator() {
        return _iterator.apply(this, arguments);
      }

      return iterator;
    }()
  }]);

  return TextLineDataset;
}(Dataset);